export default __webpack_public_path__ + "static/media/dashboard.7b3f005a.svg";